import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'amber' | 'blue' | 'green' | 'grey' | 'teal';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const variants = {
    default: 'bg-navy-lighter text-gray-300 border border-gray-700',
    amber: 'bg-amber/10 text-amber border border-amber/20',
    blue: 'bg-blue-500/10 text-blue-400 border border-blue-500/20',
    green: 'bg-green-500/10 text-green-400 border border-green-500/20',
    grey: 'bg-gray-500/10 text-gray-400 border border-gray-500/20',
    teal: 'bg-teal-500/10 text-teal-400 border border-teal-500/20'
  };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${variants[variant]} ${className}`} data-id="element-11">
      {children}
    </span>;
}